import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import routes from './routes';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

export const config = {
  base_url : process.env.VUE_APP_BASE_URL,
  file_url : process.env.VUE_APP_FILE_URL
};

Vue.prototype.appName = process.env.VUE_APP_NAME;
Vue.prototype.base_url = process.env.VUE_APP_BASE_URL;
Vue.prototype.file_url = process.env.VUE_APP_FILE_URL;

Vue.use(require('moment'));
Vue.use(VueAxios, axios);
Vue.use(VuetifyDialog, {
  warning: {},
  error: {},
  prompt: {}
})

Vue.config.productionTip = false

Vue.use(VueRouter);
const router = new VueRouter({routes});

new Vue({
  router, 
  vuetify,
  render: h => h(App)
}).$mount('#app')
